// eslint-disable-next-line no-use-before-define
import React from 'react';
export const Avatar = ({ user, onClick, }) => {
    let info = 'unknown';
    if (user != null) {
        if (user.name != null) {
            info = user.name;
        }
        else if (user.email != null) {
            info = user.email;
        }
    }
    return (React.createElement("div", { title: info, className: 'main-menu_avatar', onClick: onClick }, info[0]));
};
//# sourceMappingURL=avatar.js.map